/* eslint-disable no-irregular-whitespace */
import styles from 'components/cases/common/Interview/Interview.module.scss'
import TitleFlex from 'components/cases/common/TitleFlex'
import { useEffect, useRef } from 'react'
import { gsap, Power4 } from 'gsap'
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger'
import InterviewContents from 'components/cases/common/Interview/InterviewContents'
import { ContentData } from 'components/cases/common/Interview/fragments/type'
gsap.registerPlugin(ScrollTrigger)

const sectionTitle: { title: string; sub_title: string } = {
  title: 'Interview',
  sub_title: 'インタビュー',
}

const contentData: ContentData[][] = [
  [
    {
      type: 'imageWithCaption',
      src: '/images/img/cases/tennispointapp/interview_photo.webp',
      alt: 'インタビュー写真',
      text: 'イオン・シグナ・スポーツ・ユナイテッド株式会社 岡田 宣之さん、眞田 智和さん',
    },
    {
      type: 'sectionTitle',
      text: 'Aitriaに依頼した背景',
    },
    {
      type: 'greyBox',
      texts: [
        'プロジェクトを進行するに至っての課題は、アプリのローカライズ許諾の条件として、ブランドオーナーと現地のアプリ開発者の三者が、ドイツ本国で対面でディスカッションすることが提示されていた事にありました。そうした状況において、アイスリーさんは多くのアプリ開発実績があるだけでなくドイツに程近いウクライナに開発拠点を持ち、さらには担当してくださる方がドイツにも精通されていました。実際にドイツに1週間滞在し、日本版をどのようなアプリにするのかを議論し、一緒に検討・開発ができる事が選定理由において、大きかったように思います。',
      ],
    },
    {
      type: 'sectionTitle',
      text: 'プロジェクト進行',
    },
    {
      type: 'greyBox',
      texts: [
        'アプリ開発での最大の課題として、本国版のアプリが持っているデータベースを日本では流用ができないという問題がありました。しかし、アイスリーさんの提案で、ウクライナの開発チームも含めて一緒にドイツの現地開発者と仕様を相談した甲斐もあり、独自のデータの持ち方や連携方法を新たに構築することができました。また本国版がさまざまなホスティングサーバーを組み合わせて構築されていたのに対し、日本版ではAWSのクラウド基盤かつマネージドサービスに載せ替えることで、イオングループ基準のセキュリティ要件に適合することも出来ました。',
        'プロジェクト全体の進行を通して感じたことは、弊社の立場に立って開発・構築してくれているということです。決してアイスリーさんの作りやすいように作るのではなく、あくまでも弊社とアプリを使っていただくユーザーの立場に立ってご提案して頂いていると感じたので、スムーズにプロジェクトを進めることが出来ました。',
        'アプリのリリース後、日本のオリジナルコンテンツの配信や細やかな試合結果のデータ網羅などがユーザーの皆様から好評をいただいており、ストアのレビューも上々です。また、ドイツ本国から「良いアプリだね」と良いリアクションをもらうことができました。',
      ],
    },
    {
      type: 'sectionTitle',
      text: '今後の展望',
    },
    {
      type: 'greyBox',
      texts: [
        '現在開発中のECサイトをローンチ次第、アプリからの誘導を行います。 その上で、Web経由とアプリ経由での集客やコンバージョンレートを比較しながら、アプリから購入する際、ポイントインセンティブが付くなどのサービスも検討したいと思っています。 さらには、アプリの中でのコミュニティー形成も重要な要素だと感じておりますので、ニュースへのコメント機能追加の検討するつもりです。他には新型コロナウイルスの影響により、搭載できなかった協力会社との協業を含む機能があるため、頃合いを見てその実現にも動く予定です。それらを実現した上で、本アプリを通して、広くユーザーのみなさまにテニスをもっと身近に感じてもらえるようにできたらと考えています。',
      ],
    },
  ],
]

const tweenVars: gsap.TimelineVars = {
  y: 50,
  duration: 1,
  opacity: 0,
  ease: Power4.easeOut,
}

const Interview: React.FC = () => {
  const timeline = gsap.timeline()
  const wrapper = useRef<HTMLElement>()
  const image = useRef<HTMLImageElement>()
  const text_container = useRef<HTMLDivElement>()
  // const container = useRef<HTMLDivElement>()

  useEffect(() => {
    timeline.from(image.current, tweenVars, 0.2)
    timeline.from(text_container.current, tweenVars, 0.4)

    ScrollTrigger.create({
      animation: timeline,
      trigger: wrapper.current,
      start: 'top-=100 80%',
      toggleActions: 'play none none reverse',
    })
  }, [])

  return (
    <section className={styles.wrapper} ref={wrapper}>
      <div className={styles.content}>
        <TitleFlex sectionTitle={sectionTitle} />
        <div className={styles.article_container} ref={text_container}>
          <InterviewContents contentData={contentData} />
        </div>
      </div>
    </section>
  )
}

export default Interview
